import { render, staticRenderFns } from "./asset-manager.vue?vue&type=template&id=075a7242&"
import script from "./asset-manager.vue?vue&type=script&lang=js&"
export * from "./asset-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports